export default __webpack_public_path__ + "static/media/SEGUILI.04ff6570.TTF";